import axios from 'axios';

// polyfill promise for axios in IE11
import 'promise-polyfill/src/polyfill';

export default axios;
